var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 15.1665V9.1665M7.99984 9.1665L10.3332 11.4998M7.99984 9.1665L5.6665 11.4998",
    stroke: "#45AE51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 12.2383C14.329 11.8482 15.3332 10.9594 15.3332 9.16683C15.3332 6.50016 13.1109 5.8335 11.9998 5.8335C11.9998 4.50016 11.9998 1.8335 7.99984 1.8335C3.99984 1.8335 3.99984 4.50016 3.99984 5.8335C2.88873 5.8335 0.666504 6.50016 0.666504 9.16683C0.666504 10.9594 1.67069 11.8483 2.6665 12.2383",
    stroke: "#45AE51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.1b062183ed06a0adf4eaa6e3a34b58e0.svg";
export { ForwardRef as ReactComponent };